import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, Ref } from 'vue';
import { ToggleButtonData } from './ToggleButtonData.model';
import ToggleButton from './ToggleButton.vue';

export interface Props {
    toggleButtonData: Array<ToggleButtonData>,
    maxToggle: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButtonGroup',
  props: {
    toggleButtonData: { default: () => [] },
    maxToggle: { default: 0 }
  },
  emits: ["toggleButtonChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const toggleButtonList: Ref<Array<ToggleButtonData>> = ref(props.toggleButtonData);

const emit = __emit

const onButtonPressed = (pressedToggleButtonData: ToggleButtonData) => {
  if(!pressedToggleButtonData.readOnly) {
    let pressedButtons = 0;
    toggleButtonList.value.forEach((toggleButtonData) => {
      if (toggleButtonData.id === pressedToggleButtonData.id) {
        pressedToggleButtonData.pressed = !pressedToggleButtonData.pressed;
        toggleButtonData = pressedToggleButtonData;
      }

      if (toggleButtonData.pressed) {
        pressedButtons++;
      }
    });

    toggleButtonList.value.forEach((toggleButtonData) => {
      if (props.maxToggle > 0 && pressedButtons === props.maxToggle) {
        if (!toggleButtonData.pressed) {
          toggleButtonData.disabled = true;
        }
      } else {
        toggleButtonData.disabled = false;
      }
    });

    emit('toggleButtonChanged', pressedToggleButtonData);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, {
    class: "iodine-toggle-button-group",
    unelevated: "",
    "no-caps": "",
    "toggle-color": "primary"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toggleButtonList.value, (toggleButton) => {
        return (_openBlock(), _createBlock(ToggleButton, {
          key: toggleButton.id,
          toggleButton: toggleButton,
          onClick: ($event: any) => (onButtonPressed(toggleButton)),
          onButtonPressed: onButtonPressed,
          class: _normalizeClass({ 'iodine-button-pressed': toggleButton.pressed, 'iodine-button-disabled': toggleButton.disabled, 'iodine-button-readonly': toggleButton.readOnly }),
          disabled: toggleButton.disabled
        }, null, 8, ["toggleButton", "onClick", "class", "disabled"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})